import { useState, useCallback } from 'react';
import { Box } from '@customerio/pluma-components/react';
import * as styles from './index.css';

type HtmlPreviewFrameProps = { html: string; title: string };

// Renders message HTML in a fixed-size, fully sandboxed (`sandbox=""`) iframe scaled to fit the
// preview panel width. The sandbox is the isolation boundary, so the HTML needs no extra
// sanitization. Shared by the template and anonymous in-app message previews.
export function HtmlPreviewFrame({ html, title }: HtmlPreviewFrameProps) {
  const [scale, setScale] = useState(0);
  const containerRef = useCallback((node: HTMLDivElement | null) => {
    if (node == null) {
      setScale(0);
      return;
    }
    const observer = new ResizeObserver(() => {
      setScale(node.clientWidth / styles.IFRAME_WIDTH);
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className={styles.templatePreviewContainer}>
      {scale > 0 ? (
        <Box overflow="hidden" style={{ width: styles.IFRAME_WIDTH * scale, height: styles.IFRAME_HEIGHT * scale }}>
          <iframe
            title={title}
            srcDoc={html}
            className={styles.templatePreviewIframe}
            sandbox=""
            style={{ transform: `scale(${scale})` }}
          />
        </Box>
      ) : null}
    </div>
  );
}
